import React,{useEffect} from "react";
import { connect } from "react-redux";
import changeLogin from "../../store/Actions/LoginAction";
import {useHistory} from 'react-router-dom';
import DashboardNavbar from './DashboardNavbar';
import DashboardNavbarMobile from './DashboardNavbarMobile';
import Sidebar from './Sidebar';

function Dashboard(props) {
  const login = props.login;
  const history = useHistory()

  const logout = () => {
    localStorage.removeItem("userData");
    props.ChangeLogin(false);
    history.push("/");
  };

  useEffect(()=>{
    document.title = "VisaPro | Dashboard";
  },[])

  return (
    <div>
      <DashboardNavbar />
      <DashboardNavbarMobile />
      <Sidebar cmp={props.cmp} />
      {/* <button onClick={()=>{logout()}}>Logout</button> */}
    </div>
  );
}

const mapDispatchToProp = (dispatch) => ({
  ChangeLogin: (login) => dispatch(changeLogin(login)),
});

export default connect("",mapDispatchToProp)(Dashboard);
